
import React, { useMemo, useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import AsyncSelect from 'react-select/async';
import SweetAlert2 from 'react-sweetalert2';
import useUtils from '../../../../utiles/useUtiles';
import Footer from '../../../components/Footer';
import ModalDetailsTemplate from '../../../components/template/ModalDetailsTemplate';
import SAlert from '../../shared/SAlert';

const TemplateList: React.FC = () => {

  const [templateList, setTemplateList] = useState<any>( { count: 0, rows: [] } );
  const [loading, setLoading] = useState<boolean>( false );
  const [searchParams, setSearchParams] = useState<any>( { searchText: '', csvTypeId: null } );
  const [selectedTemplate, setSelectedTemplate] = useState<any>( null );
  const [showDeleteAlert, setShowDeleteAlert] = useState<boolean>( false );
  const [showDetails, setShowDetails] = useState<boolean>( false );
  const [pagination, setPagination] = useState<any>( {
    pageIndex: 0,
    pageSize: 10
  } );
  const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
  const axios = axiosRequest();
  const toast = toastInstance();

  useEffect( () => {
    listTemplates();
    // fetchCsvTypes();
  }, [] );

  useEffect( () => {
    // listTemplates();
  }, [searchParams] );

  useEffect( () => {
    listTemplates();
  }, [ pagination ] );

  const csvTypeOptions = ( inputValue: string ): Promise<any[]> => {
    return new Promise<any[]>( async ( resolve ) => {
      const result = await fetchCsvTypes( inputValue );
      resolve( result );
    });
  }
    

  const listTemplates = async () => {
    setLoading( true );
    const searchString = Object.keys( searchParams )
    .filter( key => searchParams[key] )
    .map( key => `${key}=${searchParams[key]}` ).join( '&' );

		const request = await axios.get( `${baseUrl()}/templates?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&${searchString}` );
    setLoading( false );
    const { error, result, message } = request.data;

		if ( error ) {
			toast.error( message );
		} else {
			setTemplateList( result );
		}
	};

  const confirmDelete = ( template: any ) => {
    setSelectedTemplate( template );
    setShowDeleteAlert( true );
  };

  const fetchCsvTypes = ( searchText: string ): Promise<any[]> => {
    return new Promise<any[]>( async ( resolve ) => {
        var query = 'page=0&pageSize=5';
        if ( searchText ) {
          query += `&searchText=${searchText}`;
        }

        const request = await axios.get( `${baseUrl()}/template_types?${query}` );
        const { error, result, message } = request.data;

        if ( error ) {
            toast.error( message );
            resolve( [] );
        } else {
            const data = result['rows'].map( (r: any) => ( {
                label: r.name,
                value: r.id 
            } ) );
            resolve( data );
        }
    } );
  };

  const onSearchChange = ( field: string, value: any ) => {
    setSearchParams( {
      ...searchParams,
      [field]: value
    } );
  };

  const handleDelete = async () => {
    setLoading( true );
		const request = await axios.delete( `${baseUrl()}/templates/${selectedTemplate.id}` );
    setLoading( false );
    const { error, result, message } = request.data;

		if ( error ) {
			toast.error( message || 'Error to delete the record' );
		} else {
      listTemplates();
      setSelectedTemplate( null );
      setShowDeleteAlert( false );
			// setTemplateList( result );
		}
  };

  const closeDetailsModal = () => {
    setSelectedTemplate( null );
    setShowDetails( false );
  };

  const openDetailsModal = ( template: any ) => {
    setSelectedTemplate( template );
    setShowDetails( true );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'csvType',
        header: 'Template Type',
        minSize: 80,
        maxSize: 150,
        Cell: ( { cell }: any ) => <span>{cell.getValue()['name']}</span>,
      },{
        accessorKey: 'network',
        header: 'Network Name',
        minSize: 80,
        maxSize: 150,
        Cell: ( { cell } ) => <span>{cell.getValue()?.name || 'NA'}</span>,
      },
      {
        accessorKey: 'name',
        header: 'Name',
        minSize: 30,
        maxSize: 50,
        Cell: ( { cell } ) => <span>{cell.getValue()}</span>,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        minSize: 30,
        maxSize: 50,
        Cell: ( { cell } ) => <span>{cell.getValue() === 1 ? 'Active' : 'Inactive'}</span>,
      },
      {
        accessorKey: 'actions',
        header: 'Action',
        minSize: 30,
        maxSize: 60,
        Cell: ( { cell } ) => <div>
            <FontAwesomeIcon
              title='View'
              icon={faEye}
              className="isPointer ml-2 cursor-pointer"
              onClick={() => openDetailsModal( cell.row.original )}
            />&nbsp;
            <FontAwesomeIcon
              title='Remove'
              icon={faTrash}
              className="isPointer ml-2 text-danger cursor-pointer"
              onClick={() => confirmDelete( cell.row.original )}
            />
        </div>,
      }
    ],
    [],
  );

  return (
    <>
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                      <div className="main-container-inner">
                        <div className="main-card revrex-data-table-card">
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                <h1 className='page-title-sm'>Templates</h1>
                                <Link to="/" className="btn btn-md btn-custom-secondary">Add</Link>
                                {/* <button type='button' className='btn btn-md btn-custom-secondary' onClick={() => setShowAddUserModal(true)}> Add </button> */}
                            </div>
                            <div className='mb-4 d-flex gap-10'>
                                <div className='flex-grow-1'>
                                  <input type={"text"} name="searchText" placeholder="Template name" className="form-control" autoComplete='new-password' onChange={( e ) => onSearchChange( 'searchText', e.target.value )} />
                                </div>
                                <div className='flex-grow-1 select-dropdown'>
                                  <AsyncSelect 
                                      cacheOptions 
                                      isClearable={true}
                                      loadOptions={csvTypeOptions} 
                                      defaultOptions 
                                      name="csvTypeId" 
                                      onChange={selectedOption => {
                                          if ( selectedOption && selectedOption['value'] ) {
                                            onSearchChange( 'csvTypeId', selectedOption['value'] );
                                          } else {
                                            onSearchChange( 'csvTypeId', null );
                                          }
                                      }} 
                                  />
                                </div>
                                <div className=''>
                                  <button type="button" className="btn btn-md btn-custom-secondary" onClick={listTemplates}>Search</button>
                                </div>
                            </div>
                            
                            <div className='template-list-table'>
                                <MaterialReactTable 
                                    columns={columns} 
                                    data={templateList?.rows} 
                                    rowCount={templateList?.count} 
                                    enableColumnOrdering={false} 
                                    enableRowSelection={false} 
                                    enableSelectAll={false}
                                    enableColumnActions={false}
                                    manualPagination
                                    onPaginationChange={setPagination}
                                    state={{ pagination }}
                                    enableSorting={false}
                                    enableGlobalFilter={true}
                                    enableFullScreenToggle={false}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    enableColumnFilters
                                    enableFilters={false}
                                />
                            </div>
                            
                        </div>
                      </div>
                      <Footer />
                    </div>
                </div>
            </div>
            <SAlert
              show={showDeleteAlert}
              showCancel={true}
              confirmBtnText="Yes"
              cancelBtnText="No"
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="secondary"
              onCancel={() => setShowDeleteAlert( false )}
              title={`Delete Record`}
              msg={`Are you sure to delete the template, ${selectedTemplate?.name}?`}
              onConfirm={() => handleDelete()}
            />
            <ModalDetailsTemplate templateId={selectedTemplate?.id} show={showDetails} handleClose={closeDetailsModal} />
            {loadingScreen( loading )}
        </div>
    </>
  );
}

export default TemplateList
